// @flow
import { stubString } from 'lodash/util'

export type appStateType = {
  productLanguage: string,
  productFormats: Array<Object>,
  relatedProductFormatInCart: Object | void
}

const state: appStateType = {
  productLanguage: stubString(),
  productFormats: [],
  relatedProductFormatInCart: undefined
}

export default state
